import React from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import $ from 'jquery'
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
function Attendancedetails() {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");

    // const navigate = useNavigate();
    const Swal = require('sweetalert2')

    const [branch, setBranch] = useState([]);
    const [branchId, setBranchId] = useState("");

    const [shifttype, setshifttype] = useState([]);
    const [shiftTypeId, setShiftTypeId] = useState("");

    const [dept, setDept] = useState([]);
    const [deptId, setDeptId] = useState("");

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [staff, setStaff] = useState([]);

    //Modal For Punch-in(Present)
    const [showModal, setShowModal] = useState(false);
    const [showBulkModal, setShowBulkModal] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [punchInTime, setPunchInTime] = useState("");
    const [checkedEmployees, setCheckedEmployees] = useState([]);
    //Modal for Punch-Out(Present)
    const [modalType, setModalType] = useState("");

    const getPunchInValue = (item) => item.adminmarked_in || item.first_punch_in || "";
    const getPunchOutValue = (item) => item.adminmarked_out || item.first_punch_out || "";
    const hasPunchIn = (item) => Boolean(getPunchInValue(item));
    const hasPunchOut = (item) => Boolean(getPunchOutValue(item));
    const formatSelectedDate = (date) =>
        date?.toLocaleDateString("en-GB") || "";

    const formatPunchTime = (timeValue) => {
        if (!timeValue) return "";

        return new Date(`1970-01-01T${timeValue}`).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        });
    };

    //Fetch Branch name, Shift type name, Department name for dropdown
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [branchRes, shiftRes, deptRes] = await Promise.all([
                    axios.get(`${baseurladdress}getallbranchs`, {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }),
                    axios.get(`${baseurladdress}getallshifttype`, {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }),
                    axios.get(`${baseurladdress}getalldepts`, {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }),
                ]);

                setBranch(branchRes.data.response);
                setshifttype(shiftRes.data.response);
                setDept(deptRes.data.response);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    // Fetch Staff name while selecting the branch name
    useEffect(() => {
        if (!branchId) {
            setStaff([]);
            return;
        }
        axios.get(
            `${baseurladdress}staffbybranch/${branchId}`,
            {
                headers: {
                    Authorization: `Bearer ${accesstoken}`
                }
            }
        )
            .then((res) => {
                console.log("API Response:", res.data);
                setStaff(res.data.response || []);
            })
            .catch((err) => {
                console.error(err);
                setStaff([]);
            });
    }, [branchId]);

    //Present (Punch-In) Modal box 
    const openAttendanceModal = (employee) => {
        // if (!checkedEmployees.includes(employee.staff_id)) {
        //     Swal.fire(
        //         "Warning",
        //         `Please check the checkbox - ${employee.staff_name}`,
        //         "warning"
        //     );
        //     return;
        // }

        setModalType("IN");
        setSelectedEmployee(employee);
        setPunchInTime("");
        setShowModal(true);
    };
    const closeAttendanceModal = () => {
        setShowModal(false);
        setSelectedEmployee(null);
        setPunchInTime("");
        setModalType("");
    };

    const closeBulkAttendanceModal = () => {
        setShowBulkModal(false);
        setPunchInTime("");
        setCheckedEmployees([]);
    };

    //Punch-Out Modal box   
    const openPunchOutModal = (employee) => {

        if (!checkedEmployees.includes(employee.staff_id)) {

            Swal.fire(
                "Warning",
                `Please check the checkbox - ${employee.staff_name}`,
                "warning"
            );
            return;
        }

        setModalType("OUT");
        setSelectedEmployee(employee);
        setPunchInTime("");
        setShowModal(true);
    };
    // Punch-In  API call for marking attendance 
    const submitAttendance = async () => {

        if (!punchInTime) {
            Swal.fire(
                "Warning",
                "Please enter Punch-In Time",
                "warning"
            );
            return;
        }

        try {

            const response = await axios.post(
                `${baseurladdress}adminmarkattendance`,
                {
                    staffId: selectedEmployee.staff_id,
                    punchInTime: punchInTime,
                    accessuserid: accessuserid
                },
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            if (response.data.success) {

                Swal.fire(
                    "Success",
                    "Attendance Marked Successfully",
                    "success"
                );

                closeAttendanceModal();

                const refresh = await axios.get(
                    `${baseurladdress}staffbybranch/${branchId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`
                        }
                    }
                );

                setStaff(refresh.data.response || []);
            }

        } catch (error) {

            console.log(error);

            Swal.fire(
                "Error",
                "Attendance marking failed",
                "error"
            );
        }
    };

    //Punch - Out API call for marking attendance
    // const submitPunchOut = async () => {
    //     if (!punchInTime) {

    //         Swal.fire(
    //             "Warning",
    //             "Please enter Punch-Out Time",
    //             "warning"
    //         );

    //         return;
    //     }

    //     try {
    //         const response = await axios.post(
    //             `${baseurladdress}adminmarkpunchout`,
    //             {
    //                 staffId: selectedEmployee.staff_id,
    //                 punchOutTime: punchInTime,
    //                 accessuserid: accessuserid
    //             },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${accesstoken}`
    //                 }
    //             }
    //         );

    //         if (response.data.success) {

    //             Swal.fire(
    //                 "Success",
    //                 "Punch Out Updated Successfully",
    //                 "success"
    //             );

    //             closeAttendanceModal();

    //             const refresh = await axios.get(
    //                 `${baseurladdress}staffbybranch/${branchId}`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${accesstoken}`
    //                     }
    //                 }
    //             );

    //             setStaff(refresh.data.response || []);
    //         }

    //     } catch (error) {

    //         console.log(error);

    //         Swal.fire(
    //             "Error",
    //             "Punch Out Failed",
    //             "error"
    //         );
    //     }
    // };




    const submitPunchOut = async () => {
        if (!punchInTime) {
            Swal.fire(
                "Warning",
                "Please enter Punch-Out Time",
                "warning"
            );
            return;
        }

        try {
            const response = await axios.post(
                `${baseurladdress}adminmarkpunchout`,
                {
                    staffId: selectedEmployee.staff_id,
                    punchOutTime: punchInTime,
                    accessuserid: accessuserid
                },
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            if (response.data.success) {
                Swal.fire(
                    "Success",
                    response.data.message || "Punch Out Updated Successfully",
                    "success"
                );

                closeAttendanceModal();

                const refresh = await axios.get(
                    `${baseurladdress}staffbybranch/${branchId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`
                        }
                    }
                );

                setStaff(refresh.data.response || []);
            } else {
                Swal.fire(
                    "Error",
                    response.data.message || "Punch Out Failed",
                    "error"
                );
            }
        } catch (error) {
            console.log(error);

            Swal.fire(
                "Error",
                "Punch Out Failed",
                "error"
            );
        }
    };
    //Select All Checkbox handling for marking attendance in bulk
    const handleSelectAll = (e) => {

        if (e.target.checked) {

            const allStaffIds = staff.map(
                (item) => item.staff_id
            );

            setCheckedEmployees(allStaffIds);

        } else {

            setCheckedEmployees([]);
        }
    };
    const handleCheckboxChange = (staffId) => {

        setCheckedEmployees((prev) => {

            if (prev.includes(staffId)) {
                return prev.filter(
                    (id) => id !== staffId
                );
            }

            return [...prev, staffId];
        });
    };

    //Bulk Attendance Modal box
    // const openBulkAttendanceModal = () => {
    //     if (checkedEmployees.length === 0) {
    //         Swal.fire(
    //             "Warning",
    //             "Please select at least one employee",
    //             "warning"
    //         );

    //         return;
    //     }
    //     setModalType("IN");
    //     setPunchInTime("");
    //     setShowBulkModal(true);
    // };
    const openBulkAttendanceModal = () => {

        if (checkedEmployees.length === 0) {

            Swal.fire(
                "Warning",
                "Please select at least one employee",
                "warning"
            );

            return;
        }

        const selectedStaff = staff.filter(emp =>
            checkedEmployees.includes(emp.staff_id)
        );

        const allPunchedIn = selectedStaff.every(emp =>
            hasPunchIn(emp) && !hasPunchOut(emp)
        );

        setModalType(allPunchedIn ? "OUT" : "IN");

        setPunchInTime("");
        setShowBulkModal(true);
    };
    //Mark Bulk employee Punch-in attendance
    const submitBulkAttendance = async () => {

        if (!punchInTime) {
            Swal.fire(
                "Warning",
                "Please enter Punch-In Time",
                "warning"
            );
            return;
        }
        try {
            for (const staffId of checkedEmployees) {
                await axios.post(
                    `${baseurladdress}adminmarkattendance`,
                    {
                        staffId,
                        punchInTime,
                        accessuserid
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`
                        }
                    }
                );
            }

            Swal.fire(
                "Success",
                "Attendance Marked Successfully",
                "success"
            );

            closeBulkAttendanceModal();

            const refresh = await axios.get(
                `${baseurladdress}staffbybranch/${branchId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            setStaff(refresh.data.response || []);

            setCheckedEmployees([]);

        } catch (error) {

            console.log(error);

            Swal.fire(
                "Error",
                "Attendance marking failed",
                "error"
            );
        }
    };

    //Mark Bulk employee Punch-Out attendance
    const submitBulkPunchOut = async () => {

        if (!punchInTime) {

            Swal.fire(
                "Warning",
                "Please enter Punch-Out Time",
                "warning"
            );

            return;
        }

        if (checkedEmployees.length === 0) {

            Swal.fire(
                "Warning",
                "Please select at least one employee",
                "warning"
            );

            return;
        }

        try {

            for (const staffId of checkedEmployees) {

                await axios.post(
                    `${baseurladdress}adminmarkpunchout`,
                    {
                        staffId: staffId,
                        punchOutTime: punchInTime,
                        accessuserid: accessuserid
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`
                        }
                    }
                );
            }

            Swal.fire(
                "Success",
                "Punch Out Updated Successfully",
                "success"
            );

            closeBulkAttendanceModal();

            const refresh = await axios.get(
                `${baseurladdress}staffbybranch/${branchId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            setStaff(refresh.data.response || []);

        } catch (error) {

            console.log(error);

            Swal.fire(
                "Error",
                "Punch Out Failed",
                "error"
            );
        }
    };


    useEffect(() => {

        if (!deptId || !shiftTypeId) {
            setStaff([]);
            return;
        }

        axios.get(
            `${baseurladdress}searchattendance`,
            {
                params: {
                    departmentId: deptId,
                    shiftTypeId: shiftTypeId,
                    attendanceDate: selectedDate
                        .toISOString()
                        .split("T")[0]
                },
                headers: {
                    Authorization: `Bearer ${accesstoken}`
                }
            }
        )
            .then((res) => {
                setStaff(res.data.response || []);
            })
            .catch((err) => {
                console.log(err);
                setStaff([]);
            });

    }, [deptId, shiftTypeId, selectedDate]);
    return (
        <div>
            <Topnavbar />
            <Sidennav />

            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div className="card shadow-sm border-0">
                                <div className="card-header bg-white border-bottom">
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: "16px",
                                            width: "100%"
                                        }}
                                    >
                                        <div>
                                            <h6 className="card-title mb-0" style={{ color: "#111827", fontWeight: 700 }}>
                                                Employee Attendance Management
                                            </h6>
                                            <small className="text-muted">
                                                Admin panel for attendance marking
                                            </small>
                                        </div>

                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={openBulkAttendanceModal}
                                        >
                                            Mark Attendance
                                        </button>
                                    </div>
                                </div>

                                <div className="card-body" style={{ background: "#f8fafc" }}>
                                    <div className="row g-3 align-items-end">
                                        <div className="col-lg-3 col-md-6">
                                            <label className="form-label">Branch</label>
                                            <Select
                                                options={branch.map((item) => ({
                                                    value: item.branch_id,
                                                    label: item.branch_name,
                                                }))}
                                                value={
                                                    branchId
                                                        ? {
                                                            value: branchId,
                                                            label:
                                                                branch.find(
                                                                    (item) =>
                                                                        item.branch_id.toString() ===
                                                                        branchId.toString()
                                                                )?.branch_name || "",
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) =>
                                                    setBranchId(selectedOption ? selectedOption.value : "")
                                                }
                                                placeholder="Select Branch"
                                                isSearchable
                                            />
                                        </div>

                                        <div className="col-lg-3 col-md-6">
                                            <label className="form-label">Shift Type</label>
                                            <select
                                                className="form-control"
                                                value={shiftTypeId}
                                                onChange={(e) => setShiftTypeId(e.target.value)}
                                            >
                                                <option value="">Select Shift Type</option>
                                                {shifttype.map((item) => (
                                                    <option key={item.type_id} value={item.type_id}>
                                                        {item.type_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-lg-3 col-md-6">
                                            <label className="form-label">Department</label>

                                            <Select
                                                options={dept.map((item) => ({
                                                    value: item.dept_id,
                                                    label: item.dept_name,
                                                }))}

                                                value={
                                                    deptId
                                                        ? {
                                                            value: deptId,
                                                            label:
                                                                dept.find(
                                                                    (item) =>
                                                                        item.dept_id.toString() ===
                                                                        deptId.toString()
                                                                )?.dept_name || "",
                                                        }
                                                        : null
                                                }

                                                onChange={async (selectedOption) => {

                                                    const selectedDeptId = selectedOption
                                                        ? selectedOption.value
                                                        : "";

                                                    setDeptId(selectedDeptId);

                                                    if (!selectedDeptId || !shiftTypeId) {
                                                        setStaff([]);
                                                        return;
                                                    }

                                                    try {

                                                        const response = await axios.get(
                                                            `${baseurladdress}searchattendance`,
                                                            {
                                                                params: {
                                                                    departmentId: selectedDeptId,
                                                                    shiftTypeId: shiftTypeId
                                                                },
                                                                headers: {
                                                                    Authorization: `Bearer ${accesstoken}`
                                                                }
                                                            }
                                                        );

                                                        console.log(response.data);

                                                        setStaff(response.data.response || []);

                                                    } catch (error) {

                                                        console.log(error);

                                                        setStaff([]);
                                                    }
                                                }}

                                                placeholder="Select Department"
                                                isSearchable
                                            />
                                        </div>

                                        <div className="col-lg-3 col-md-6">
                                            <label className="form-label">Date</label>
                                            <DatePicker
                                                selected={selectedDate}
                                                onChange={(date) => setSelectedDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                wrapperClassName="w-100"
                                            />
                                        </div>
                                    </div>

                                    <div className="card mt-4 shadow-sm border-0">
                                        <div className="card-header bg-white border-bottom">
                                            <h6 className="mb-0" style={{ color: "#1f2937", fontWeight: 700 }}>
                                                Employee Attendance List
                                            </h6>
                                        </div>

                                        <div className="card-body p-0">
                                            <div className="table-responsive">
                                                <table
                                                    className="table table-bordered table-hover align-middle mb-0"
                                                    id="attdetails"
                                                >
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th style={{ width: "50px" }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id="selectAll"
                                                                    checked={
                                                                        staff.length > 0 &&
                                                                        checkedEmployees.length === staff.length
                                                                    }
                                                                    onChange={handleSelectAll}
                                                                />
                                                            </th>
                                                            <th>Employee Name</th>
                                                            <th>Shift</th>
                                                            <th>Date</th>
                                                            <th>Punch In</th>
                                                            <th className="text-end">Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {staff.length > 0 ? (
                                                            staff.map((item) => (
                                                                <tr key={item.staff_id}>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={checkedEmployees.includes(item.staff_id)}
                                                                            onChange={() => handleCheckboxChange(item.staff_id)}
                                                                        />
                                                                    </td>

                                                                    <td>{item.staff_name}</td>

                                                                    <td>{item.shift_name}</td>

                                                                    <td>{formatSelectedDate(selectedDate)}</td>
                                                                    <td>
                                                                        {hasPunchIn(item) ? (
                                                                            <>
                                                                                {formatPunchTime(getPunchInValue(item))}
                                                                                {" - "}
                                                                                {hasPunchOut(item)
                                                                                    ? formatPunchTime(getPunchOutValue(item))
                                                                                    : "-"}
                                                                            </>
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </td>
                                                                    {/*   <td>
                                                                        {hasPunchIn(item) || hasPunchOut(item) ? (
                                                                            <>
                                                                                {hasPunchIn(item)
                                                                                    ? formatPunchTime(getPunchInValue(item))
                                                                                    : hasPunchOut(item)
                                                                                        ? formatPunchTime(getPunchOutValue(item))
                                                                                        : "Not Punched"}

                                                                                {hasPunchIn(item) && hasPunchOut(item) && (
                                                                                    <>
                                                                                        {" - "}
                                                                                        {formatPunchTime(getPunchOutValue(item))}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            "Not Punched"
                                                                        )}
                                                                    </td>*/}
                                                                    <td className="text-end">

                                                                        {item.shift_name === "No Shift Assigned" ? (

                                                                            <button
                                                                                className="btn btn-secondary btn-sm"
                                                                                disabled
                                                                            >
                                                                                NO SHIFT
                                                                            </button>

                                                                        ) : !hasPunchIn(item) ? (

                                                                            <button
                                                                                className="btn btn-success btn-sm"
                                                                                style={{ minWidth: "92px", fontWeight: 700 }}
                                                                                onClick={() => openAttendanceModal(item)}
                                                                            >
                                                                                PRESENT
                                                                            </button>

                                                                        ) : hasPunchIn(item) && !hasPunchOut(item) ? (

                                                                            <button
                                                                                className="btn btn-primary btn-sm"
                                                                                style={{ minWidth: "92px", fontWeight: 700 }}
                                                                                onClick={() => openPunchOutModal(item)}
                                                                            >
                                                                                IN
                                                                            </button>

                                                                        ) : (

                                                                            <button
                                                                                className="btn btn-warning btn-sm"
                                                                                disabled
                                                                                style={{ minWidth: "92px", fontWeight: 700 }}
                                                                            >
                                                                                COMPLETED
                                                                            </button>

                                                                        )}

                                                                    </td>
                                                                    {/*   <td className="text-end">
                                                                        {item.shift_name === "No Shift Assigned" ? (
                                                                            <button
                                                                                className="btn btn-secondary btn-sm"
                                                                                disabled
                                                                            >
                                                                                NO SHIFT
                                                                            </button>
                                                                        ) : !hasPunchOut(item) && !hasPunchIn(item) ? (
                                                                            <button
                                                                                className="btn btn-success btn-sm"
                                                                                style={{ minWidth: "92px", fontWeight: 700 }}
                                                                                onClick={() => openAttendanceModal(item)}
                                                                            >
                                                                                PRESENT
                                                                            </button>
                                                                        ) : !hasPunchOut(item) ? (
                                                                            <button
                                                                                className="btn btn-primary btn-sm"
                                                                                style={{ minWidth: "92px", fontWeight: 700 }}
                                                                                onClick={() => openPunchOutModal(item)}
                                                                            >
                                                                                IN
                                                                            </button>
                                                                        ) : (
                                                                            <span
                                                                                className="badge"
                                                                                style={{
                                                                                    minWidth: "92px",
                                                                                    padding: "0.6rem 0.75rem",
                                                                                    backgroundColor: "#f59e0b",
                                                                                    color: "#111827",
                                                                                    fontWeight: 700,
                                                                                    borderRadius: "0.35rem"
                                                                                }}
                                                                            >
                                                                                COMPLETED
                                                                            </span>
                                                                        )}
                                                                    </td>*/}
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="6" className="text-center py-4">
                                                                    No Employees Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {showModal && (
                                <>
                                    <div
                                        className="modal fade show"
                                        style={{
                                            display: "block",
                                            backgroundColor: "rgba(0,0,0,0.5)"
                                        }}
                                    >
                                        <div className="modal-dialog">
                                            <div className="modal-content">

                                                <div className="modal-header">
                                                    <h5 className="modal-title">
                                                        {modalType === "IN"
                                                            ? "Mark Attendance"
                                                            : "Mark Punch Out"}
                                                    </h5>

                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        onClick={closeAttendanceModal}
                                                    >X</button>
                                                </div>

                                                <div className="modal-body">

                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Employee Name
                                                        </label>

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={selectedEmployee?.staff_name || ""}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            {modalType === "IN"
                                                                ? "Enter Punch-In Time"
                                                                : "Enter Punch-Out Time"}
                                                        </label>

                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            value={punchInTime}
                                                            onChange={(e) =>
                                                                setPunchInTime(e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                </div>

                                                <div className="modal-footer">

                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={closeAttendanceModal}
                                                    >
                                                        Not Now
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={
                                                            modalType === "IN"
                                                                ? submitAttendance
                                                                : submitPunchOut
                                                        }
                                                    >
                                                        Submit
                                                    </button>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-backdrop fade show"></div>
                                </>
                            )}
                            {showBulkModal && (
                                <>
                                    <div
                                        className="modal fade show"
                                        style={{
                                            display: "block",
                                            backgroundColor: "rgba(0,0,0,0.5)"
                                        }}
                                    >
                                        <div className="modal-dialog">
                                            <div className="modal-content">

                                                <div className="modal-header">
                                                    <h5 className="modal-title">
                                                        {modalType === "IN"
                                                            ? "Mark Bulk Attendance"
                                                            : "Mark Bulk Punch Out"}
                                                    </h5>

                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        onClick={closeBulkAttendanceModal}
                                                    >X</button>
                                                </div>

                                                <div className="modal-body">

                                                    <div className="mb-3">

                                                        <label className="form-label">
                                                            Selected Employees
                                                        </label>

                                                        <div
                                                            style={{
                                                                maxHeight: "150px",
                                                                overflowY: "auto",
                                                                border: "1px solid #ddd",
                                                                padding: "10px"
                                                            }}
                                                        >

                                                            {staff
                                                                .filter(emp =>
                                                                    checkedEmployees.includes(emp.staff_id)
                                                                )
                                                                .map(emp => (
                                                                    <div key={emp.staff_id}>
                                                                        {emp.staff_name}
                                                                    </div>
                                                                ))
                                                            }

                                                        </div>

                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            {modalType === "IN"
                                                                ? "Enter Punch-In Time"
                                                                : "Enter Punch-Out Time"}
                                                        </label>

                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            value={punchInTime}
                                                            onChange={(e) =>
                                                                setPunchInTime(e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                </div>

                                                <div className="modal-footer">

                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={closeBulkAttendanceModal}
                                                    >
                                                        Not Now
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={
                                                            modalType === "IN"
                                                                ? submitBulkAttendance
                                                                : submitBulkPunchOut
                                                        }
                                                    >
                                                        Submit
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-backdrop fade show"></div>
                                </>
                            )}
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Attendancedetails;
